import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  LockOutlined,
  UserOutlined,
  HomeOutlined,
  QuestionCircleOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { Button, Form, Input, Alert, Row, Popover, FloatButton } from "antd";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor, SignInDoctor } from "./interfaces";
import "./Login.css";
import { getMe, signIn } from "./utils";
import {
  ALMSG_ERR_CREDENTIALS,
  ALMSG_INTERNAL_ERR,
  ALMSG_SESS_EXPIRED,
  ALMSG_TIMEOUT,
  HOME_PATH,
  INTERNAL_ERR,
  LOGIN_PATH,
  LOGIN_TOKEN,
  REGISTER_PATH,
  SESS_EXPIRED,
} from "../env";
import ReactGA from "react-ga4";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { setSignedInDoctor } = useContext(SignedInContext);
  const [cookies, setCookie] = useCookies([LOGIN_TOKEN]);
  const [wrongCredentials, setWrongCredentials] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const search = useLocation().search;
  let sessionExpired: boolean =
    parseInt(new URLSearchParams(search).get(SESS_EXPIRED) || "0") == 1;
  let serverError: boolean =
    parseInt(new URLSearchParams(search).get(INTERNAL_ERR) || "0") == 1;

  const onFinish = async (loginValues: SignInDoctor) => {
    const token_or_err = await signIn(loginValues);
    console.log(token_or_err);
    if (token_or_err.indexOf("Licenza non Valida") >= 0)
      setErrMsg("Abbonamento scaduto, contattaci per rinnovare");
    else if (token_or_err) {
      //console.log("Logged in! Received token for auth: ", token);
      const loggedIn: SignedInDoctor = await getMe(token_or_err);
      loggedIn.token = token_or_err;
      //console.log("Me", loggedIn);
      if (setSignedInDoctor) setSignedInDoctor(loggedIn);
      setCookie(LOGIN_TOKEN, token_or_err, {
        path: "/",
        expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 2), //expires in 2 hours
      });

      navigate("/app" + HOME_PATH);
    } else {
      //console.log("Wrong credentials!");
      setWrongCredentials(true);
    }
  };

  //LOGIN BACK

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/app" + LOGIN_PATH) {
      document.body.classList.add("login-page");
    } else {
      document.body.classList.remove("login-page");
    }

    // Cleanup function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("login-page");
    };
  }, [location.pathname]);

  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    window.location.href = "https://www.physiocheck.it/";
  };

  //Remove msg after a few seconds
  useEffect(() => {
    setTimeout(() => {
      setWrongCredentials(false);
      setErrMsg("");
      sessionExpired = false;
      serverError = false;
    }, ALMSG_TIMEOUT);
  }, [wrongCredentials, errMsg, sessionExpired, serverError]);

  const contentx = (
    <>
      <Row>
        <Button href="https://www.physiocheck.it/richiesta-assistenza/">
          Contattaci
        </Button>
      </Row>
    </>
  );

  return (
    <>
      {width > 560 && (
        //Desktop
        <div className="login-page ">
          <div className="forms ">
            <div className="login">
              <div className="login-header">
                <h3 className="loginf">
                  <LockOutlined rev={undefined} className="white-icon" /> LOGIN
                </h3>
                <p className="loginf2">Benvenuto in Physiocheck App</p>
              </div>
            </div>
            <Form
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                className="ant-form-item-flog"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci il tuo username!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <UserOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  placeholder="Username"
                  className="all-login-form"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci una password!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <LockOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  type="password"
                  placeholder="Password"
                  className="all-login-form"
                />
              </Form.Item>
              <Form.Item
                name="studio"
                rules={[
                  {
                    required: true,
                    message:
                      "Qui devi inserire la credenziale relativa al tuo studio!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <HomeOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  type="text"
                  placeholder="Studio Medico"
                  className="all-login-form"
                />
              </Form.Item>

              <Form.Item>
                <a
                  className="login-form-forgot"
                  href="https://www.physiocheck.it/richiesta-nuova-password/"
                >
                  Hai Dimenticato La Password?
                </a>
                <Row className="reloxxo">
                  <h5 className="login-form-forgot">
                    Non sei iscritto?{" "}
                    <a href={"/app" + REGISTER_PATH} className="theColor">
                      Iscriviti Adesso!
                    </a>
                  </h5>
                </Row>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-boton"
                >
                  Accedi
                </Button>
              </Form.Item>
            </Form>
          </div>
          <Form.Item className="detex">
            {wrongCredentials && (
              <Alert
                className="error-form"
                message={ALMSG_ERR_CREDENTIALS}
                description=""
                type="error"
                showIcon
              />
            )}
            {errMsg && (
              <Alert
                className="error-form"
                message={errMsg}
                description=""
                type="error"
                showIcon
              />
            )}
            {sessionExpired && (
              <Alert
                className="error-form"
                message={ALMSG_SESS_EXPIRED}
                description=""
                type="error"
                showIcon
              />
            )}
            {serverError && (
              <Alert
                className="error-form"
                message={ALMSG_INTERNAL_ERR}
                description=""
                type="error"
                showIcon
              />
            )}
          </Form.Item>
        </div>
      )}

      {width <= 560 && (
        //Mobile
        <div className="login-page-m">
          <div className="forms ">
            <div className="login">
              <div className="login-header">
                <h3 className="loginf">
                  <LockOutlined rev={undefined} className="white-icon" /> LOGIN
                </h3>
                <p className="loginf2">Benvenuto in Physiocheck App</p>
              </div>
            </div>
            <Form
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                className="ant-form-item-flog"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci il tuo username!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <UserOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  placeholder="Username"
                  className="all-login-form"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci una password!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <LockOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  type="password"
                  placeholder="Password"
                  className="all-login-form"
                />
              </Form.Item>
              <Form.Item
                name="studio"
                rules={[
                  {
                    required: true,
                    message:
                      "Qui devi inserire la credenziale relativa al tuo studio!",
                  },
                ]}
              >
                <Input
                  prefix={
                    <HomeOutlined
                      className="site-form-item-icon"
                      rev={undefined}
                    />
                  }
                  type="text"
                  placeholder="Studio Medico"
                  className="all-login-form"
                />
              </Form.Item>

              <Form.Item>
                <a
                  className="login-form-forgot"
                  href="https://www.physiocheck.it/richiesta-nuova-password/"
                >
                  Hai Dimenticato La Password?
                </a>
                <Row className="reloxxo">
                  <h5 className="login-form-forgot">
                    Non sei iscritto?{" "}
                    <a href={"/app" + REGISTER_PATH} className="theColor">
                      Iscriviti Adesso!
                    </a>
                  </h5>
                </Row>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-boton"
                >
                  Accedi
                </Button>
              </Form.Item>
            </Form>
          </div>
          <Form.Item className="detex">
            {wrongCredentials && (
              <Alert
                className="error-form"
                message={ALMSG_ERR_CREDENTIALS}
                description=""
                type="error"
                showIcon
              />
            )}
            {errMsg && (
              <Alert
                className="error-form"
                message={errMsg}
                description=""
                type="error"
                showIcon
              />
            )}
            {sessionExpired && (
              <Alert
                className="error-form"
                message={ALMSG_SESS_EXPIRED}
                description=""
                type="error"
                showIcon
              />
            )}
            {serverError && (
              <Alert
                className="error-form"
                message={ALMSG_INTERNAL_ERR}
                description=""
                type="error"
                showIcon
              />
            )}
          </Form.Item>
        </div>
      )}

      <Popover
        placement="leftBottom"
        title="Hai Bisogno Di Aiuto?"
        content={contentx}
      >
        <FloatButton
          icon={<QuestionCircleOutlined rev={undefined} />}
          type="default"
          style={{ right: 24 }}
        />
      </Popover>

      <Popover
        placement="rightBottom"
        className="orcoup"
        title="Visita il nostro sito"
      >
        <FloatButton
          icon={<GlobalOutlined rev={undefined} />}
          onClick={handleClick}
        >
          Vai al sito
        </FloatButton>
      </Popover>
    </>
  );
};

/*
REMEMBER ME FORM ITEM
<Form.Item>
  <Form.Item name="remember" valuePropName="checked" noStyle>
    <Checkbox>Remember me</Checkbox>
  </Form.Item>
</Form.Item>
*/

export default Login;
